module.exports = __webpack_public_path__ + "img/button-left.4d96d7e9.png";